import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "btn-container" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-center align-center"
}
const _hoisted_3 = { style: {"font-size":"18px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScopeComponent = _resolveComponent("ScopeComponent")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_CoursesListFiltersComponent = _resolveComponent("CoursesListFiltersComponent")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_DialogComponent = _resolveComponent("DialogComponent")!
  const _component_CourseActivationDialog = _resolveComponent("CourseActivationDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "pa-1 ma-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_ScopeComponent, { onOnScopeChange: _ctx.search }, null, 8, ["onOnScopeChange"]),
      _createVNode(_component_v_card_title, { class: "d-flex flex-gap justify-space-between flex-column flex-sm-row pb-2" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("titles.courses")), 1),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.userRights?.includes('9.3.') && _ctx.showAddBtn)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  id: "coursesList-btn-add",
                  dark: "",
                  class: "success",
                  to: { name: _ctx.addUrl }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("titles.addCourse")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.userRights?.includes('9.12.') && _ctx.showAddBtn)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  id: "coursesList-btn-importInstructors",
                  dark: "",
                  class: "success--text",
                  variant: "outlined",
                  to: { name: _ctx.instructorsUrl }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("titles.ImportInstructors")), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "ma-2" }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_CoursesListFiltersComponent, {
            onSearch: _ctx.search,
            modelValue: _ctx.filtersInputs,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtersInputs) = $event)),
            value: _ctx.filtersInputs,
            filtersData: _ctx.filtersOptions,
            loading: _ctx.loadingFilters || _ctx.loading
          }, null, 8, ["onSearch", "modelValue", "value", "filtersData", "loading"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "ma-2" }),
      _createVNode(_component_v_card_actions, { class: "d-flex flex-wrap justify-end align-center px-2 mb-2 actions-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            id: "coursesList-btn-search",
            class: "ma-1 white--text",
            color: "primary",
            variant: "flat",
            loading: _ctx.loading,
            disabled: _ctx.loadingFilters || _ctx.loading ,
            onClick: _ctx.search
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("buttons.search")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]),
          _createVNode(_component_v_btn, {
            id: "coursesList-btn-reset",
            class: "ma-1",
            color: "secondary",
            variant: "flat",
            disabled: _ctx.loadingFilters || _ctx.loading,
            onClick: _ctx.resetSearch
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("buttons.reset")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table_server, {
            class: "clickable",
            headers: _ctx.headers,
            items: _ctx.courseList,
            "items-length": _ctx.totalItems,
            "loading-text": _ctx.$t('labels.loading'),
            "no-data-text": _ctx.$t('labels.noData'),
            loading: _ctx.loading,
            page: _ctx.tablePage,
            "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tablePage) = $event)),
            "items-per-page": _ctx.tableLimit,
            "onUpdate:itemsPerPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tableLimit) = $event)),
            "items-per-page-options": _ctx.limitOption,
            "items-per-page-text": _ctx.$t('RowsPerPage'),
            "mobile-breakpoint": "sm",
            "onUpdate:options": _ctx.onTableOptionsUpdate,
            "onClick:row": _cache[3] || (_cache[3] = (event, { item }) => _ctx.openCourseSubjectList(item))
          }, {
            loading: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('labels.loading')), 1)
            ]),
            "no-data": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('labels.noData')), 1)
            ]),
            "item.index": _withCtx(({ index }) => [
              _createTextVNode(_toDisplayString((_ctx.tablePage - 1) * _ctx.tableLimit + 1 + index), 1)
            ]),
            "item.courseName": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.$utils.trim(_ctx.$utils.servertranslate(item.courseName))), 1)
            ]),
            "item.studyPlan": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.$utils.trim(_ctx.$utils.servertranslate(item.studyPlan))), 1)
            ]),
            "item.courseType": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_ctx.$utils.servertranslate((item.courseType as { baName: string }).baName)), 1)
            ]),
            "item.actions": _withCtx(({ item }) => [
              (_ctx.showAction && item.isEditable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_switch, {
                      id: "coursesList-btn-updateStatus",
                      color: "success",
                      class: "mx-2",
                      "hide-details": "",
                      modelValue: item.active,
                      "onUpdate:modelValue": ($event: any) => ((item.active) = $event),
                      onClick: _withModifiers(($event: any) => (_ctx.showActivation(item)), ["stop"]),
                      title: _ctx.$t(`labels.${item.active ? 'active' : 'inactive'}`)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick", "title"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["headers", "items", "items-length", "loading-text", "no-data-text", "loading", "page", "items-per-page", "items-per-page-options", "items-per-page-text", "onUpdate:options"])
        ]),
        _: 1
      }),
      (_ctx.showDialog)
        ? (_openBlock(), _createBlock(_component_DialogComponent, {
            key: 0,
            onClose: _ctx.cancel,
            modelValue: _ctx.showDialog,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDialog) = $event)),
            value: _ctx.showDialog
          }, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("titles.confirmMessage")), 1)
            ]),
            body: _withCtx(() => [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.active ? "courseDeactivateConfirm" : "courseActivateConfirm")), 1)
            ]),
            actions: _withCtx(() => [
              _createVNode(_component_v_btn, {
                id: "courseActivateDialog-btn-cancel",
                class: "mx-1 secondary white--text",
                onClick: _ctx.cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                id: "courseActivateDialog-btn-confirm",
                class: "mx-1 success",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activate()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("buttons.confirm")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClose", "modelValue", "value"]))
        : _createCommentVNode("", true),
      (_ctx.subjectsToBeActivated)
        ? (_openBlock(), _createBlock(_component_CourseActivationDialog, {
            key: 1,
            subjectsToBeActivated: _ctx.subjectsToBeActivated,
            active: _ctx.active,
            courseId: String(_ctx.courseId),
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal(_ctx.active))),
            onActivationDone: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeModal(!_ctx.active)))
          }, null, 8, ["subjectsToBeActivated", "active", "courseId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}